import { useSearch } from "@tanstack/react-router";
import { FormFieldParentFieldDrawer } from "components/Drawers/FormFieldParentFieldDrawer/FormFieldParentFieldDrawer.tsx";
import { DrawerId } from "types/models.ts";

interface SearchParams {
    [`parentField-formFieldId`]: string;
}

export const DrawerContainer = () => {
    const searchParams = useSearch({ strict: false }) as SearchParams;

    return (
        <>
            {searchParams[`${DrawerId.ParentField}-formFieldId`] && (
                <FormFieldParentFieldDrawer formFieldId={searchParams[`${DrawerId.ParentField}-formFieldId`]} />
            )}
        </>
    );
};
